<template>
    <div class="container-fluid">
       <nav aria-label="breadcrumb">
            <ol class="breadcrumb bg-primary" >
                <li class="breadcrumb-item" v-for="path in breadcrumb" v-bind:key="path.id">
                    <a @click="getFiles(path); getbreadcrumb(path)" class="text-white d-flex align-items-center"><i class="ri-home-4-line mr-1">
                </i>{{path.name}}</a></li>
            </ol>
        </nav>
         <div class="col-lg-12">
              <div v-show="show_folder">
                    <div class="card card-block card-stretch card-transparent">
                        <div class="card-header d-flex justify-content-between pb-0">
                            <div class="header-title">
                                <h4 class="card-title">Folders</h4>
                            </div>
                        </div>
                    </div>
                    <b-row>
                        <div class="col-md-6 col-sm-6 col-lg-3" v-for="folder in folder" v-bind:key="folder.id" >
                            <div v-bind:style="{cursor : 'pointer'}" class="card card-block card-stretch card-height">
                                <div class="card-body d-flex flex-column align-items-center justify-content-center" :value="folder.name" @click="getFiles(folder); getbreadcrumb(folder)">
                                    <img v-if="breadcrumb.find((bc) => bc.name === folder.name) == undefined" src="/img/svgs/unopenFolder.svg" />
                                    <img v-else src="/img/svgs/folder.svg" />
                                    <span class="mb-2">{{folder.name}}</span>
                                </div>
                            </div>
                        </div>
                    </b-row>
                    <!-- <b-row>
                        <div class="col-md-6 col-sm-6 col-lg-3" v-for="folder in folder" v-bind:key="folder.id" >
                        <div v-bind:style="{cursor : 'pointer'}" class="card card-block card-stretch card-height" >
                            <div class="card-body" :value="folder.name" @click="getFiles(folder); getbreadcrumb(folder)"  >                            
                                <div class="d-flex justify-content-between"> 
                                        <div class="folder">
                                            <div>
                                                <i class="ri-folder-line text-primary" style="font-size: 24px;"></i>
                                            </div>
                                        </div>
                                    </div> 
                                    <div class="folder">
                                        <h5 class="mb-2">{{folder.name}}</h5>
                                        <p class="mb-2"><i class="lar la-clock text-danger mr-2 font-size-20"></i>{{folder.modified_date}}</p>
                                    </div>
                            </div>
                        </div>
                        </div>
                    </b-row> -->
              </div>

                <div v-show="show_subfolder">
                    <div class="card card-block card-stretch card-transparent">
                        <div class="card-header d-flex justify-content-between pb-0">
                            <div v-show="show_subfolder" class="header-title">
                                <h4 class="card-title">Sub Folders</h4>
                            </div>
                        </div>
                    </div>
                    <b-row>
                        <div class="col-md-6 col-sm-6 col-lg-3" v-for="folder in subfolder" v-bind:key="folder.id" >
                            <div v-bind:style="{cursor : 'pointer'}" class="card card-block card-stretch card-height">
                                <div class="card-body d-flex flex-column align-items-center justify-content-center" :value="folder.name" @click="getFiles(folder); getbreadcrumb(folder)">
                                    <img v-if="breadcrumb.find((bc) => bc.name === folder.name) == undefined" src="/img/svgs/unopenFolder.svg" />
                                    <img v-else src="/img/svgs/folder.svg" />
                                    <span class="mb-2">{{folder.name}}</span>
                                </div>
                            </div>
                        </div>
                    </b-row>
                    <!-- <b-row>
                        <div class="col-md-6 col-sm-6 col-lg-3" v-for="folder in subfolder" v-bind:key="folder.id" >
                        <div v-bind:style="{cursor : 'pointer'}" class="card card-block card-stretch card-height" >
                            <div class="card-body" :value="folder.name" @click="getFiles(folder); getbreadcrumb(folder)"  >                            
                                <div class="d-flex justify-content-between"> 
                                        <div class="folder">
                                            <div>
                                                <i class="ri-folder-line text-primary" style="font-size: 24px;"></i>
                                            </div>
                                        </div>
                                    </div> 
                                    <div class="folder">
                                        <h5 class="mb-2">{{folder.name}}</h5>
                                        <p class="mb-2"><i class="lar la-clock text-danger mr-2 font-size-20"></i>{{folder.modified_date}}</p>
                                    </div>
                            </div>
                        </div>
                        </div>
                    </b-row> -->
                </div>
                <br>

                <div class="row">
                <div class="col-lg-12">
                     <div class="d-flex align-items-center justify-content-between welcome-content mb-3">
                         <div class="card card-block card-stretch card-transparent">
                            <div class="card-header d-flex justify-content-between pb-0">
                                <div class="header-title">
                                    <h4 class="card-title">Files</h4>
                                </div>
                                <!-- <b-button pill variant="orange"  @click="downloadAll(link)"> Download All</b-button> -->
                            </div>
                        </div>
                     </div>
                </div>
            </div>

            <div class="icon i-list">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card card-block card-stretch card-height">
                                <div class="card-body">
                                    <div class="table-responsive">
                                        <table class="table mb-0 table-borderless tbl-server-info">
                                        <thead>
                                            <tr>
                                                <th scope="col">File Name</th>
                                                <th scope="col">File Type</th>
                                                <th scope="col">Last Update</th>
                                                <th scope="col">File Size</th>
                                                <th scope="col">Download</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="file in common" v-bind:key="file.id">
                                                <td>
                                                    <div class="d-flex align-items-center">
                                                        <template>
                                                        <!-- <a :data-title="file.name" :data-url="`http://localhost:3000/download?name=demo.pdf`" @click="$root.$emit('bv::show::modal', 'viewer-modal', $event.target)" v-b-modal.viewer-modal > -->
                                                        <a :data-title="file.name" :data-url="file.url" @click="$root.$emit('bv::show::modal', 'viewer-modal', $event.target)" v-b-modal.viewer-modal >
                                                            <span style="color:#535F6B;">{{file.name}}</span>
                                                            
                                                        </a>
                                                        </template>
                                                    </div>
                                                </td>
                                                <td>{{file.extension}}</td>
                                                <td>{{file.modified_date}}</td>
                                                <td>{{file.file_size}}</td>
                                                <td><b-button pill variant="outline-orange" @click="onClick(file.url, file.name, file.extension)">Download</b-button></td>
                                            </tr>
                                        </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
    </div>
        
</template>

<script>
import Vue from 'vue';
import axios from 'axios'
import VueAxios from 'vue-axios'
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import saveAs from 'save-as';

const URL = require("../../../../config");
Vue.use(VueAxios, axios)

export default {
    name:'Folders',
    data() {
        return {
            data: true,
            folder: [],
            subfolder: [],
            common: [],
            link: [],
            show_subfolder: false,
            show_folder: true,
            breadcrumb: [],
            breadcrumb_loc: []                     
        }
    },
    async mounted() {
        let user = JSON.parse(localStorage.getItem("user"));
        let response = await Vue.axios.get(URL.api.URL+'/api/mediaPack' ,{ params: { m: this.$route.meta.uid , merchant: user.merchant_code, role:user.role_id, category: 'Slot'} });

        this.folder = response.data.folder;
        this.breadcrumb.push({name: "", loc: this.folder[0].loc});
        this.common = response.data.common_file;
    },
    methods: {
        getFiles: async function(item) {
            this.folder.forEach(element => {
                if (element.loc === item.loc) {
                    this.show_folder = true;                    
                } else {
                    this.show_folder = false;
                }                
            });

            var path = item.loc + item.name;            
           
            let user = JSON.parse(localStorage.getItem("user"));
            let response = await Vue.axios.get(URL.api.URL+'/api/mediaPack', { params: { m: this.$route.meta.uid , merchant: user.merchant_code, loc: path, category: 'Slot'}});
            
            this.common = response.data.common_file
            this.subfolder = response.data.subfolder

            if (this.subfolder != null && item.name != "") {
                this.show_subfolder = true;
            } else {
                this.show_subfolder = false;
            }
        
            this.link = [];
            this.common.forEach(element => {
                var url = {
                    link : element.url,
                    name: element.name + '.' + element.extension
                }

                this.link.push(url);
            });            
        },
        onClick(fileurl, filename, extension) {
            axios({
                url: fileurl, params: { m: this.$route.meta.uid},
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download',  filename+'.'+extension);
                document.body.appendChild(fileLink);

                fileLink.click();
            });
        },
        getbreadcrumb(item){
            var path_loc = item.loc;
            var valObj = this.breadcrumb.filter(function(elem) {
                if(elem.name == item.name) 
                return elem
            });

            for( var i = 0; i < this.breadcrumb.length; i++){ 
                if ( this.breadcrumb[i].name == item.name) { 
                    this.breadcrumb.splice(i + 1); 
                }
            }

            if(valObj.length == 0)
                this.breadcrumb.push({name:item.name, loc: path_loc})
        },
        downloadAll() {
            var zip = new JSZip();
            var count = 0;
            var zipFilename = "media pack.zip";
            var urls = this.link

            urls.forEach(function(url) {               
                var filename = url.name;               
                JSZipUtils.getBinaryContent(url.link, function (err, data) {
                    if(err) {
                        throw err; 
                    }
                    
                    zip.file(filename, data, {binary:true});
                    count++;
    
                    if (count == urls.length) {
                        zip.generateAsync({type:'blob'}).then(function(content) {
                            saveAs(content, zipFilename);
                        });
                    }
                });
            });
        },
    },
}
</script>